import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { ConsumidorModule } from './../../restrito/consumidor/consumidor.module';
import { MenuComponent } from './menu.component';
import { MenuRoutingModule } from './menu.routing.module';

@NgModule({
  imports: [CommonModule, NgbModule.forRoot(), ConsumidorModule],
  declarations: [MenuComponent],
  exports: [MenuComponent, MenuRoutingModule]
})
export class MenuModule {}



// WEBPACK FOOTER //
// ./src/app/shared-layout/menu/menu.module.ts